import React, { useState, useEffect } from "react";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineDelete } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { BsDownload } from "react-icons/bs";
import { BiCommentError } from "react-icons/bi";
import { RiFilePaperLine } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import Action from "../../components/Action";
import { getBeneficiries } from "../../store/actions/BenActions";
import { useParams } from "react-router";
import { style, color } from "../../styles/Style";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import {
  deleteFund,
  getFundById,
  updateFund,
} from "../../store/actions/FundActions";
import {
  addBenWhoGotFund,
  getBenWhoGotFunds,
  updateBenWhoGotFund,
  deleteBenWhoGotFund,
} from "../../store/actions/BenGotFundsActions";
import { changeFromTimeStamp } from "../../utils/changeFromTimeStamp";
import { getFundTypes } from "../../store/actions/FundTypesActions";
import { styles } from "../../styles/downloads";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import ContentLoader from "react-content-loader";
import { ToastContainer } from "react-toastify";

function ViewFund() {
  // dispatch
  const dispatch = useDispatch();

  const [regFund, setRegFund] = useState({
    id: "",
    createdAt: "",
    fundType: {
      idValue: "",
    },
    name: "",
    fundDescription: "",
  });
  // reducers

  const beneficiaries = useSelector((state) => state.beneficiries);
  const fund = useSelector((state) => state.fundsState.fund);
  const receipents = useSelector((state) => state.fundedBeneficiries);
  const fundsTypes = useSelector((state) => state.fundsTypes);
  const loaders = useSelector((state) => state.loadersState);

  const [openUpperTab, setOpenUpperTab] = useState(1);

  // overlays
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    setAddBeneOverlay(!addBenOverlay);
    setFundedBeneficiary({
      id: "",
      beneficiary: {
        idValue: "",
      },
      beneficiaryContributionAmount: "",
      fundedAmount: "",
      receivedAt: "",
      receivedBy: "",
    });
  }

  const { fundId } = useParams();
  const selectedFundId = fundId;

  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedFund) {
    setEditBeneOverlay(!editBenOverlay);
    setFundedBeneficiary({
      beneficiary: {
        idValue: passedFund.beneficiary.id,
      },
      id: passedFund.id,
      beneficiaryContributionAmount: passedFund.beneficiaryContributionAmount,
      fundedAmount: passedFund.fundedAmount,
      receivedAt: changeFromTimeStamp(passedFund.receivedAt),
      receivedBy: passedFund.receivedBy,
    });
  }

  const [editFund, setEditFund] = useState(0);
  function editFundController(passedFund) {
    setEditFund(!editFund);
    setRegFund({
      id: passedFund.id,
      createdAt: passedFund.createdAt,
      fundType: {
        idValue: passedFund.fundType.id,
      },
      name: passedFund.name,
      fundDescription: passedFund.fundDescription,
    });
  }
  const [addFund, setAddFund] = useState(0);
  function AddFundController() {
    setAddFund(!addFund);
  }
  const [filterFundOverlay, setFilterFundOverlay] = useState(0);
  function FundFilterOverlayController() {
    setFilterFundOverlay(!filterFundOverlay);
  }

  // handle assocciation update
  const handleFundUpdate = (e) => {
    e.preventDefault();
    const id = regFund.id;
    const updatedFund = {
      id: regFund.id,
      createdAt: regFund.createdAt,
      fundType: {
        idValue: regFund.fundType.idValue,
      },
      name: regFund.name,
      fundDescription: regFund.fundDescription,
    };
    dispatch(updateFund(updatedFund, id, closeFundAfterUpdating));
  };
  // declare beneficiary fund
  const [fundedBeneficiary, setFundedBeneficiary] = useState({
    beneficiary: {
      idValue: "",
    },
    id: "",
    beneficiaryContributionAmount: "",
    fundedAmount: "",
    receivedAt: "",
    receivedBy: "",
  });
  // for insurance table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "ReceivedAt",
        accessor: "receiveDate",
      },
      {
        Header: "Fund(frw)",
        accessor: "fundAmount",
      },
      {
        Header: "RecepientContribution(frw)",
        accessor: "beneficiaryContributionAmount",
      },
      {
        Header: "Recipient",
        accessor: "receivedOne",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // transform funds data
  let [loadedReceipnts, setLoadedReceipnts] = useState([]);
  useEffect(() => {
    for (let i = 0; i < receipents.length; i++) {
      const receipnt = {
        count: i + 1,
        beneficiary: `${receipents[i].beneficiary.firstName} ${receipents[i].beneficiary.lastName}`,
        receiveDate: changeFromTimeStamp(receipents[i].receivedAt),
        beneficiaryContributionAmount:
          receipents[i].beneficiaryContributionAmount,
        fundAmount: receipents[i].fundedAmount,
        receivedOne: (
          <div className="py-1 px-2 rounded text-indigo-500 bg-indigo-50 font-normal fit-content">
            {receipents[i].receivedBy}
          </div>
        ),
        benAmount: receipents[i].benAmount,
        action: (
          <Action
            editAction={() => {
              editOverlayController(receipents[i]);
            }}
            deleteAction={() => {
              handleDelete(receipents[i].id);
            }}
            benId={receipents[i].id}
          />
        ),
      };
      setLoadedReceipnts((loadedReceipnts) => [...loadedReceipnts, receipnt]);
      if (
        loaders.fundedBen.deletingAction &&
        loaders.fundedBen.deletingAction.deleting
      ) {
        const currentReceipents = loadedReceipnts;
        const newData = currentReceipents.map((ourFund) =>
          ourFund.id === loaders.fundedBen.deletingAction.id
            ? {
                ...ourFund,
                action: (
                  <div className="spinner red-spinner m-auto">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                  </div>
                ),
              }
            : ourFund
        );
        setLoadedReceipnts(newData);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receipents, loaders.fundedBen.deletingAction]);

  let [loadingReceipentss, setLoadingReceipentss] = useState([]);

  useEffect(() => {
    setLoadingReceipentss([]);
    for (let i = 0; i < 5; i++) {
      const receipnt = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        receiveDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiaryContributionAmount: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        fundAmount: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        receivedOne: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        benAmount: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };
      setLoadingReceipentss((loadingReceipentss) => [
        ...loadingReceipentss,
        receipnt,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaders.fundedBen.fetchingLoaders]);

  // handle delete
  const handleDelete = (id) => {
    dispatch(deleteBenWhoGotFund(id));
  };
  // update reduces after effect
  useEffect(() => {
    dispatch(getFundTypes());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getBeneficiries());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getBenWhoGotFunds());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getFundById(selectedFundId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const DownloadFunds = () => (
    <Document>
      <Page style={styles.body}>
        <View style={styles.table}>
          <View style={styles.tableHeaderRow}>
            <View style={styles.tableCol20}>
              <Text style={styles.tableHeaderCell}>Beneficiary</Text>
            </View>
            <View style={styles.tableCol20}>
              <Text style={styles.tableHeaderCell}>Received at</Text>
            </View>
            <View style={styles.tableCol20}>
              <Text style={styles.tableHeaderCell}>Fund(rwf)</Text>
            </View>
            <View style={styles.tableCol20}>
              <Text style={styles.tableHeaderCell}>
                {" "}
                RecepientContribution(frw)
              </Text>
            </View>
            <View style={styles.tableCol20}>
              <Text style={styles.tableHeaderCell}>Recipient</Text>
            </View>
          </View>

          {receipents.map((recipient, index) => (
            <View style={styles.tableRow} key={recipient.id}>
              <View style={styles.tableCol20}>
                <Text style={styles.tableCell}>
                  {recipient.beneficiary.firstName}{" "}
                  {recipient.beneficiary.lastName}
                </Text>
              </View>
              <View style={styles.tableCol20}>
                <Text style={styles.tableCell}>{recipient.receivedAt}</Text>
              </View>
              <View style={styles.tableCol20}>
                <Text style={styles.tableCell}>{recipient.fundedAmount}</Text>
              </View>
              <View style={styles.tableCol20}>
                <Text style={styles.tableCell}>
                  {recipient.beneficiaryContributionAmount}
                </Text>
              </View>
              <View style={styles.tableCol20}>
                <Text style={styles.tableCell}>{recipient.receivedBy}</Text>
              </View>
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );

  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }
  const selectedBeneficiary = beneficiriesOption.filter(
    (beneficiary) => beneficiary.value === fundedBeneficiary.beneficiary.idValue
  );
  let history = useHistory();
  // handle delete
  const handleDeleteFund = (id) => {
    dispatch(deleteFund(id, redirectAfterDelete));
  };

  function redirectAfterDelete() {
    history.push("/services/funds");
  }
  // handle funded beneficiary submit
  const handleFundedBeneficiarySubmit = (e) => {
    e.preventDefault();
    if (fundedBeneficiary.id) {
      const id = fundedBeneficiary.id;
      const updatedFundedBeneficiary = {
        beneficiary: {
          idValue: fundedBeneficiary.beneficiary.idValue,
        },
        beneficiaryContributionAmount:
          fundedBeneficiary.beneficiaryContributionAmount,
        fundedAmount: fundedBeneficiary.fundedAmount,
        receivedAt: fundedBeneficiary.receivedAt,
        receivedBy: fundedBeneficiary.receivedBy,
      };
      dispatch(
        updateBenWhoGotFund(
          updatedFundedBeneficiary,
          id,
          closeReceipentAfterUpdating
        )
      );
    } else {
      const newFundedBen = {
        ...fundedBeneficiary,
        fundId: { idValue: fundId },
      };
      dispatch(addBenWhoGotFund(newFundedBen, closeReceipentFormAfterAdding));
    }
  };

  const fundTypesOption = [];
  for (let i = 0; i < fundsTypes.length; i++) {
    const type = {
      value: fundsTypes[i].id,
      label: fundsTypes[i].fundName,
    };
    fundTypesOption.push(type);
  }

  // closing product after cu
  function closeReceipentFormAfterAdding() {
    benOverlayController();
    setFundedBeneficiary({
      id: "",
      beneficiary: {
        idValue: "",
      },
      beneficiaryContributionAmount: "",
      fundedAmount: "",
      receivedAt: "",
      receivedBy: "",
    });
  }

  function closeReceipentAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiary: {
        idValue: "",
      },
      beneficiaryContributionAmount: "",
      fundedAmount: "",
      receivedAt: "",
      receivedBy: "",
    });
  }
  // closing product after u

  function closeFundAfterUpdating() {
    editFundController({
      id: "",
      createdAt: "",
      fundType: {
        idValue: "",
      },
      name: "",
      fundDescription: "",
    });
  }
  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>
      {(!loaders.fund.loadingOne && !fund.id) |
      loaders.fund.loadingOneFailedMsg ? (
        <div
          className={
            !loaders.fund.loadingOneFailedMsg
              ? "bg-white mx-10 h-60 flex  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold"
              : "bg-red-100 mx-10 h-60 flex text-xs rounded  text-center py-2 px-4 text-red-500 font-semibold"
          }
        >
          <div className="m-auto">
            {!loaders.fund.loadingOneFailedMsg ? (
              <div className="flex-col">
                <RiFilePaperLine className="text-3xl mx-auto my-3" />{" "}
                <p>This fund is not found</p>{" "}
              </div>
            ) : (
              <div className="flex-col">
                <BiCommentError className="text-3xl mx-auto my-3" />{" "}
                <p>{loaders.fund.loadingOneFailedMsg}</p>{" "}
              </div>
            )}
          </div>
        </div>
      ) : loaders.fund.loadingOne ? (
        <div className="bg-white mx-10 h-60 flex">
          <div className="spinner m-auto indigo-spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      ) : (
        <div className="mx-10 bg-white">
          <div className="flex flex-col md:flex-row p-10 pl-10 pb-0">
            <h2 className="font-semibold">
              <Link
                to="/services/funds"
                className="hover:text-indigo-500 text-indigo-300"
              >
                Clothes {">"}
              </Link>{" "}
              <span className="font-normal">{fund.name}</span>
            </h2>
            <div className="md:m-auto mt-2 md:mr-0">
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                    : "hidden"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? benOverlayController()
                    : AddFundController();
                }}
              >
                <FiEdit />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "hidden"
                    : "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? benOverlayController()
                    : editFundController(fund);
                }}
              >
                <FiEdit />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "hidden"
                    : "p-2 mr-2 rounded text-red-500 border border-red-500 hover:bg-red-100"
                }
                onClick={() => {
                  handleDeleteFund(fundId);
                }}
              >
                <AiOutlineDelete
                  className={
                    loaders.fund.deletingAction &&
                    loaders.fund.deletingAction.deleting
                      ? " refresh-loader"
                      : " "
                  }
                />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-200 hover:bg-gray-100"
                    : "hidden"
                }
                onClick={() => {
                  openUpperTab === 1
                    ? filterOverlayController()
                    : FundFilterOverlayController();
                }}
              >
                <FiFilter />
              </button>
              <button
                className={
                  openUpperTab === 1
                    ? "p-2 mr-2 rounded text-gray-500 border border-gray-200 hover:bg-gray-100"
                    : "hidden"
                }
                onClick={() => {
                  dispatch(getBenWhoGotFunds());
                }}
              >
                <FcRefresh
                  className={
                    loaders.fundedBen.fetchingLoaders ? " refresh-loader" : " "
                  }
                />
              </button>

              <PDFDownloadLink
                document={<DownloadFunds />}
                fileName="funds.pdf"
                className={openUpperTab === 1 ? "inline" : "hidden"}
              >
                <button className="p-2 mr-2 rounded text-gray-500 border border-gray-200 hover:bg-gray-100">
                  <BsDownload />
                </button>
              </PDFDownloadLink>
            </div>
          </div>
          <div className="flex mt-2 flex-wrap">
            <div className="w-full">
              <ul
                className="flex mb-0 list-none flex-wrap  font-normal  flex-row w-full"
                role="tablist"
              >
                <li className="-mb-px  last:mr-0 ml-10">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0   block leading-normal" +
                      (openUpperTab === 1
                        ? " text-white bg-indigo-500 rounded rounded-r-none border-b-2 border-" +
                          color +
                          "-500"
                        : " text-indigo-50 bg-indigo-300 rounded rounded-r-none border-b-2 border-indigo-300")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(1);
                    }}
                    data-toggle="tab"
                    href="#link1"
                    role="tablist"
                  >
                    <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                    Recipient
                  </a>
                </li>
                <li className="-mb-px  last:mr-0">
                  <a
                    className={
                      "text-xs   px-5 py-1 pl-0  block leading-normal " +
                      (openUpperTab === 2
                        ? " text-white bg-indigo-500 rounded rounded-l-none border-b-2 border-" +
                          color +
                          "-500"
                        : "text-indigo-50 bg-indigo-300 border-b-2 rounded rounded-l-none border-indigo-300")
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      setOpenUpperTab(2);
                    }}
                    data-toggle="tab"
                    href="#link2"
                    role="tablist"
                  >
                    <i className="fas fa-cog text-base mr-1"></i> Information
                  </a>
                </li>
              </ul>
              <div className="relative flex flex-col min-w-0 break-words  w-full mb-2">
                <div>
                  <div className="tab-content tab-space">
                    <div
                      className={
                        openUpperTab === 1 ? "flex flex-col" : "hidden"
                      }
                      id="link1"
                    >
                      <div className="pb-5 px-0 pr-10 flex flex-wrap  w-full">
                        {/* insurance table */}
                        <div className="w-full">
                          {(!loaders.fundedBen.fetchingLoaders &&
                            receipents?.length < 1) |
                          loaders.fundedBen.fetchFailedMessage ? (
                            <div
                              className={
                                !loaders.fundedBen.fetchFailedMessage
                                  ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                                  : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                              }
                            >
                              <p className="m-auto">
                                {!loaders.fundedBen.fetchFailedMessage
                                  ? "No funded beneficiary record"
                                  : loaders.fundedBen.fetchFailedMessage}
                              </p>
                            </div>
                          ) : (
                            <Table
                              data={
                                loaders.fundedBen.fetchingLoaders
                                  ? loadingReceipentss
                                  : loadedReceipnts
                              }
                              columns={columns}
                            />
                          )}{" "}
                        </div>
                      </div>
                    </div>
                    {/* Funds table */}
                    <div
                      className={
                        openUpperTab === 2 ? "flex flex-col" : "hidden"
                      }
                      id="link1"
                    >
                      <div className="pb-5 px-0 flex flex-wrap  w-full">
                        <div className="w-full flex flex-col my-3 ml-10 mr-10 border">
                          <div className="flex flex-col md:flex-row  p-5">
                            <div className="font-semibold md:w-2/12">
                              Fund type
                            </div>
                            <div className="text-justify md:w-8/12">
                              {fund.fundType.fundName}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* end.... */}
          {/*add insurance overlay  */}
          <div
            className={
              addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
            }
          >
            <Overlay>
              <form
                className="bg-white m-auto  rounded"
                onSubmit={handleFundedBeneficiarySubmit}
              >
                <div
                  className={
                    loaders.fundedBen.message
                      ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                      : "hidden"
                  }
                >
                  <p>{loaders.fundedBen.message}</p>
                </div>
                <div className="p-10">
                  <div className="flex">
                    <h2 className="font-semibold  w-80">
                      {addBenOverlay
                        ? "Register recipient"
                        : "Change recipient info"}
                    </h2>
                    <div className="m-auto mr-0">
                      <button
                        className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                        onClick={() => {
                          addBenOverlay
                            ? benOverlayController()
                            : editOverlayController({
                                id: "",
                                beneficiary: {
                                  id: "",
                                },
                              });
                        }}
                      >
                        <IoCloseOutline className="text-white" />{" "}
                      </button>
                    </div>
                  </div>{" "}
                  <div className="flex flex-wrap">
                    <div className="w-full">
                      <div className="flex flex-col pt-3">
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Beneficiary Id</label>
                          <Select
                            options={beneficiriesOption}
                            value={beneficiriesOption.find(
                              (obj) =>
                                obj.value ===
                                fundedBeneficiary.beneficiary.idValue
                            )}
                            onChange={(e) =>
                              setFundedBeneficiary({
                                ...fundedBeneficiary,
                                beneficiary: {
                                  idValue: e.value,
                                },
                              })
                            }
                          />
                        </div>
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Name </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={
                                fundedBeneficiary.beneficiary.idValue
                                  ? selectedBeneficiary[0].name
                                  : ""
                              }
                              readOnly
                            />
                          </div>
                        </div>
                        <div className="flex">
                          {/*  field */}
                          <div className="py-2  w-1/2 mr-2">
                            <label>Fund(rwf) </label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="number"
                                className={style.field.input}
                                value={fundedBeneficiary.fundedAmount}
                                onChange={(e) =>
                                  setFundedBeneficiary({
                                    ...fundedBeneficiary,
                                    fundedAmount: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                          {/*  field */}
                          <div className="py-2 w-1/2">
                            <label>Recipient Contribution(rwf)</label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="number"
                                className={style.field.input}
                                value={
                                  fundedBeneficiary.beneficiaryContributionAmount
                                }
                                onChange={(e) =>
                                  setFundedBeneficiary({
                                    ...fundedBeneficiary,
                                    beneficiaryContributionAmount:
                                      e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2  w-full">
                          <div>
                            <label>Receive Date</label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="date"
                                className={style.field.input}
                                value={fundedBeneficiary.receivedAt}
                                onChange={(e) =>
                                  setFundedBeneficiary({
                                    ...fundedBeneficiary,
                                    receivedAt: e.target.value,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2 w-full">
                          <label>Recipient </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={fundedBeneficiary.receivedBy}
                              onChange={(e) =>
                                setFundedBeneficiary({
                                  ...fundedBeneficiary,
                                  receivedBy: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>

                        {/* save btn */}
                        <button
                          type="submit"
                          className={style.loginBtn}
                          disabled={loaders.fundedBen.sendingLoader}
                        >
                          {!loaders.fundedBen.sendingLoader ? (
                            <p className="m-auto">
                              {addBenOverlay ? "Save" : "Update"}
                            </p>
                          ) : (
                            <div className="spinner m-auto">
                              <div className="bounce1"></div>
                              <div className="bounce2"></div>
                              <div className="bounce3"></div>
                            </div>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </Overlay>
          </div>
          {/*edit Fund overlay  */}
          <div className={editFund ? "flex w-screen" : "hidden"}>
            <Overlay>
              <div className="bg-white m-auto  rounded">
                <div
                  className={
                    loaders.fund.message
                      ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                      : "hidden"
                  }
                >
                  <p>{loaders.fund.message}</p>
                </div>
                <div className="p-10">
                  <div className="flex">
                    <h2 className="font-semibold  w-80">
                      {"Change fund info"}
                    </h2>
                    <div className="m-auto mr-0">
                      <button
                        className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                        onClick={() => {
                          editFundController({
                            id: "",
                            fundType: {
                              idValue: "",
                            },
                          });
                        }}
                      >
                        <IoCloseOutline className="text-white" />{" "}
                      </button>
                    </div>
                  </div>{" "}
                  <form className="flex flex-wrap" onSubmit={handleFundUpdate}>
                    <div className="w-full">
                      <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                        <div>
                          <div className="flex flex-col pt-3">
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Name </label>
                              <div className={style.field.parentDiv}>
                                <input
                                  type="text"
                                  className={style.field.input}
                                  value={regFund.name}
                                  onChange={(e) =>
                                    setRegFund({
                                      ...regFund,
                                      name: e.target.value,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Fund type </label>
                              <Select
                                options={fundTypesOption}
                                value={fundTypesOption.find(
                                  (obj) =>
                                    obj.value === regFund.fundType.idValue
                                )}
                                onChange={(e) =>
                                  setRegFund({
                                    ...regFund,
                                    fundType: {
                                      idValue: e.value,
                                    },
                                  })
                                }
                              />
                            </div>
                            {/*  field */}
                            {/* <div className="py-2 w-full">
                              <label>Description </label>
                              <div className={style.field.parentDiv}>
                                <textarea
                                  className={style.field.input}
                                  value={regFund.fundDescription}
                                  onChange={(e) =>
                                    setRegFund({
                                      ...regFund,
                                      fundDescription: e.target.value,
                                    })
                                  }
                                ></textarea>
                              </div>
                            </div> */}

                            {/* save btn */}
                            <button
                              type="submit"
                              className={style.loginBtn}
                              disabled={loaders.fund.sendingLoader}
                            >
                              {!loaders.fund.sendingLoader ? (
                                <p className="m-auto">{"Save"}</p>
                              ) : (
                                <div className="spinner m-auto">
                                  <div className="bounce1"></div>
                                  <div className="bounce2"></div>
                                  <div className="bounce3"></div>
                                </div>
                              )}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Overlay>
          </div>
          {/* filter fund  overlay */}
          <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
            <Overlay>
              <div className="p-10 bg-white m-auto  rounded">
                <div className="flex">
                  <h2 className="font-semibold">{"Filter recipients"}</h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        filterOverlayController();
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-col pt-3">
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Beneficiary range</label>
                    <div className="flex w-full">
                      <Select options={beneficiaries} className="w-1/2 mr-2" />

                      <Select options={beneficiaries} className="w-1/2" />
                    </div>{" "}
                  </div>

                  {/*  field */}
                  <div className="py-2 w-full">
                    <div className="flex w-full">
                      <label>Receive date range </label>

                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Guhera"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="date"
                          className={style.field.input}
                          placeholder="Kugeza"
                        />
                      </div>
                    </div>
                  </div>

                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Fund range </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Guhera"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Kugeza"
                        />
                      </div>
                    </div>
                  </div>
                  {/*  field */}
                  <div className="py-2 w-full">
                    <label>Recipient amount range </label>
                    <div className="flex w-full">
                      <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Guhera"
                        />
                      </div>
                      <div className={style.field.parentDiv + " w-1/2"}>
                        <input
                          type="text"
                          className={style.field.input}
                          placeholder="Kugeza"
                        />
                      </div>
                    </div>
                  </div>
                  {/* save btn */}
                  <button type="submit" className={style.loginBtn}>
                    <p className="m-auto">{"Apply"}</p>
                  </button>
                </div>
              </div>
            </Overlay>
          </div>
        </div>
      )}
    </DashLayout>
  );
}

export default ViewFund;
